import { Injectable, EventEmitter } from '@angular/core';
import { CookieService } from './cookie.service';
import { LoginResponse, AccessTokenResponse } from '../../models/login';
import { LolLoggerService } from '../../common/shared/lol-logger.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SharedDataService {
  // constant string to be used as key value
  static readonly userLoginData: string = 'userLoginData';
  static readonly accessToken: string = 'AccessToken';
  private static SharedInstance = new SharedDataService(new CookieService()); // static member to persist one instance in life cycle of the app

  reloadProfileImage = new EventEmitter();
  // Virendra: This should not be saving other data
  workOrderData: ''; // accessing the data of work order from dashboard to work Order
  // javascript object shall be used as dictionary through app to save session related information.
  dataStore = {};
  private instance = SharedDataService.SharedInstance; // instace variable to access shared instance.

  constructor(private cookieService: CookieService) {
  }

  getInstance(): SharedDataService {
    if (this.instance == null) {
      this.instance = SharedDataService.SharedInstance;
    }

    return this.instance;
  }

  tryRestoreSession() {
    const data = this.cookieService.getCookie(SharedDataService.userLoginData);
    if (data != null && data.length > 0) {
      const userResponse: LoginResponse = JSON.parse(data) as LoginResponse;

      this.getInstance().dataStore[SharedDataService.userLoginData] = userResponse;
      try {
        const access = this.cookieService.getCookie(SharedDataService.accessToken);
        if (access) {
          const at = JSON.parse(access);
          this.getInstance().dataStore[SharedDataService.accessToken] = at;
        }
      } catch (error) {
        LolLoggerService.info('Error ', error);
      }
    }
  }

  saveAccessToken(accessToken: AccessTokenResponse) {
    this.getInstance().dataStore[SharedDataService.accessToken] = accessToken;
    this.cookieService.setCookie(SharedDataService.accessToken, JSON.stringify(accessToken), 5);
  }
  saveUserLoginData(userData: LoginResponse) {
    // saves user login information to local variable.. can be access throughout the application
    this.getInstance().dataStore[SharedDataService.userLoginData] = userData;

    // saves the information to cookies
    this.cookieService.setCookie(SharedDataService.userLoginData, JSON.stringify(userData).trim(), 5, 'evolve');
  }

  deleteUserInformation() {
    this.cookieService.deleteCookie(SharedDataService.userLoginData);
    this.getInstance().dataStore[SharedDataService.userLoginData] = null;
    this.cookieService.deleteCookie(SharedDataService.accessToken);
    this.getInstance().dataStore[SharedDataService.accessToken] = null;
  }
}
